import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminSeoCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Connexion en cours...");

  useEffect(() => {
    const code = searchParams.get("code");
    const token = localStorage.getItem("admin_token");
    if (!code || !token) {
      setMessage("Impossible de connecter Google.");
      return;
    }

    const connect = async () => {
      try {
        await axios.get(`${API}/seo/auth/callback?code=${encodeURIComponent(code)}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        navigate("/admin/seo");
      } catch (err) {
        setMessage("Connexion Google échouée.");
      }
    };

    connect();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b1020] text-white">
      <p data-testid="seo-callback-message">{message}</p>
    </div>
  );
};

export default AdminSeoCallbackPage;